import { SnakeGame } from "./games/SnakeGame";
import { TicTacToeGame } from "./games/TicTacToeGame";
import { MemoryMatchGame } from "./games/MemoryMatchGame";
import { NeonReflexGame } from "./games/NeonReflexGame";
import { PlinkoGame } from "./games/PlinkoGame";
import { NeonDodgeGame } from "./games/NeonDodgeGame";

const cabinets = [
    {
        id: "snake",
        title: "SNAKE",
        subtitle: "eat · grow · survive",
        icon: "fa-worm",
        accent: "lime",
        borderClass: "border-neon-lime",
        colorVar: "var(--neon-lime)",
        Component: SnakeGame,
    },
    {
        id: "tictactoe",
        title: "TIC-TAC-TOE",
        subtitle: "you vs the machine",
        icon: "fa-hashtag",
        accent: "cyan",
        borderClass: "border-neon-cyan",
        colorVar: "var(--neon-cyan)",
        Component: TicTacToeGame,
    },
    {
        id: "memory",
        title: "MEMORY MATCH",
        subtitle: "focus · flip · match",
        icon: "fa-brain",
        accent: "amber",
        borderClass: "border-neon-amber",
        colorVar: "var(--neon-amber)",
        Component: MemoryMatchGame,
    },
    {
        id: "reflex",
        title: "NEON REFLEX",
        subtitle: "tap the pulse",
        icon: "fa-bolt",
        accent: "pink",
        borderClass: "border-neon-pink",
        colorVar: "var(--neon-pink)",
        Component: NeonReflexGame,
    },
    {
        id: "plinko",
        title: "PLINKO",
        subtitle: "aim · drop · multiply",
        icon: "fa-coins",
        accent: "amber",
        borderClass: "border-neon-amber",
        colorVar: "var(--neon-amber)",
        Component: PlinkoGame,
    },
    {
        id: "dodge",
        title: "NEON DODGE",
        subtitle: "steer · survive · loop",
        icon: "fa-rocket",
        accent: "cyan",
        borderClass: "border-neon-cyan",
        colorVar: "var(--neon-cyan)",
        Component: NeonDodgeGame,
    },
];

export const GamesGrid = ({ resetSignal }) => {
    return (
        <section id="games" className="relative">
            <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-20">
                <div className="mb-10 md:mb-14 flex items-end justify-between flex-wrap gap-4">
                    <div>
                        <p className="font-pixel text-xl neon-pink mb-2">◆ CABINET LINEUP</p>
                        <h2 className="font-pixel text-4xl md:text-6xl neon-cyan">
                            PICK A GAME
                        </h2>
                    </div>
                    <p className="font-body text-sm md:text-base text-gray-400 max-w-sm">
                        Four cabinets, one dark arcade. All playable from your keyboard or touch — no coins required.
                    </p>
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    {cabinets.map((cab) => {
                        const { Component } = cab;
                        return (
                            <div
                                key={cab.id + resetSignal}
                                id={`game-${cab.id}`}
                                data-testid={`game-cabinet-${cab.id}`}
                                className={`arcade-cabinet ${cab.borderClass} p-5 md:p-7 scanlines`}
                            >
                                <div className="flex items-center justify-between mb-5 relative z-10">
                                    <div className="flex items-center gap-3">
                                        <span
                                            className="inline-flex items-center justify-center w-11 h-11 rounded-lg border-2"
                                            style={{ borderColor: cab.colorVar, boxShadow: `0 0 12px ${cab.colorVar}` }}
                                        >
                                            <i className={`fa-solid ${cab.icon}`} style={{ color: cab.colorVar, textShadow: `0 0 10px ${cab.colorVar}` }} />
                                        </span>
                                        <div>
                                            <h3
                                                className="font-pixel text-2xl md:text-3xl"
                                                style={{ color: cab.colorVar, textShadow: `0 0 8px ${cab.colorVar}` }}
                                            >
                                                {cab.title}
                                            </h3>
                                            <p className="text-xs text-gray-500 font-pixel tracking-widest uppercase">
                                                {cab.subtitle}
                                            </p>
                                        </div>
                                    </div>
                                    <span className="font-pixel text-xs neon-amber hidden sm:inline">
                                        · CAB {cabinets.indexOf(cab) + 1} ·
                                    </span>
                                </div>

                                <div className="relative z-10">
                                    <Component />
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
